var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "Аналитика";
var Blockchain = "Блокчейн";
var Compliance = "Соответствие требованиям";
var Compute = "Вычисления";
var Containers = "Контейнеры";
var Databases = "Базы данных";
var Games = "Игры";
var Migration = "Миграция";
var Mobile = "Мобильные технологии";
var Networking = "Сетевые решения";
var Robotics = "Робототехника";
var Satellite = "Спутниковые системы";
var Security = "Безопасность";
var Serverless = "Бессерверные решения";
var Storage = "Хранилище";
var WebApps = "Веб-приложения";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "Artifact";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "Резервное копирование";
var Batch = "Batch";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "Budgets";
var Chatbot = "Чат-бот";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Конфигурация";
var Connect = "Подключение";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dash";
var DataSync = "DataSync";
var DataZone = "DataZone";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "Обнаружение";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "Health";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "С одним";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Organizations";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "Персонализация";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "QuickSight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RoboMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "VMWare";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C#",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "Интеграция приложений",
	"AR/VR": "Дополненная реальность / Виртуальная реальность",
	"Architecture Strategy": "Архитектурная стратегия",
	"Artificial Intelligence": "Искусственный интеллект",
	Blockchain: Blockchain,
	"Business applications": "Бизнес-приложения",
	"Cloud Financial Management": "Управление финансами в облаке",
	"Cloud Foundations": "Основы для облачных вычислений",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "Контактный центр",
	Containers: Containers,
	"Data Integration": "Интеграция данных",
	Databases: Databases,
	"Developer Tools": "Инструменты для разработчиков",
	"End-User Computing (EUC)": "Вычисления для конечных пользователей (EUC)",
	"Front-End Development": "Фронтенд-разработка",
	Games: Games,
	"Generative AI": "Генеративный искусственный интеллект",
	"High Performance Computing (HPC)": "Высокопроизводительные вычисления",
	"Identity Management": "Управление идентификацией",
	"Machine Learning": "Машинное обучение",
	"Machine Learning & AI": "Машинное обучение и искусственный интеллект",
	"Management & Governance": "Управление",
	"Media services": "Сервиса мультимедиа",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "Сеть и доставка контента",
	"Quantum Technologies": "Квантовые технологии",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "Безопасность, идентификация и соответствие нормативным требованиям",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "API Gateway",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "APP Config",
	"App Mesh": "App Mesh",
	"App Runner": "App Runner",
	"App Studio": "App Studio",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Сервис обнаружения приложений",
	"Application Migration Service": "Сервис миграции приложений",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Диспетчер аудита",
	Aurora: Aurora,
	"Auto Scaling": "Auto Scaling",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "Сервис выставления счетов",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Менеджер сертификатов",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Clean Rooms",
	"Cloud Control API": "API для управления облаком",
	"Cloud Development Kit (CDK)": "Комплект для облачной разработки (CDK)",
	"Cloud Directory": "Облачный каталог",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "Облачная глобальная сеть WAN",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "Оптимизатор вычислительных ресурсов",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Cost Explorer",
	Dash: Dash,
	"Data Exchange": "Обмен данными",
	"Data Pipeline": "Data Pipeline",
	"Database Migration Service (DMS)": "Сервис миграции баз данных (DMS)",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "Глубокое обучение",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Сервис каталогов",
	"Distro for OpenTelemetry": "Distro для OpenTelemetry",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Elastic Block Storage (EBS)",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute (EC2)",
	"Elastic Container Registry (ECR)": "Elastic Container Registry (ECR)",
	"Elastic Container Service (ECS)": "Elastic Container Service (ECS)",
	"Elastic Disaster Recovery (DRS)": "Эластичное аварийное восстановление (DRS)",
	"Elastic File System (EFS)": "Эластичная файловая система (EFS)",
	"Elastic Inference": "Эластичный вывод",
	"Elastic Kubernetes Service (EKS)": "Эластичный сервис Kubernetes (EKS)",
	"Elastic Transcoder": "Эластичный транскодер",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "Симулятор внедрения отказов",
	"File Cache": "Кэш файлов",
	FinSpace: FinSpace,
	"Firewall Manager": "Диспетчер брандмауэра",
	Forecast: Forecast,
	"Fraud Detector": "Детектор мошенничества",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Международный ускоритель",
	Glue: Glue,
	"Ground Station": "Наземная станция",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "Центр идентификацииIAM",
	"Identity and Access Management (IAM)": "Управление идентификацией и доступом (IAM)",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Интерактивный видеосервис",
	"Internet of Things (IoT)": "Интернет вещей",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Сервис управления ключами (KMS)",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Мастер запуска",
	Lex: Lex,
	"License Manager": "License Manager",
	Lightsail: Lightsail,
	"Local Zones": "Локальные зоны",
	"Location Service": "Служба определения местоположения",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "Модернизация мэйнфреймов",
	"Managed Blockchain": "Управляемый блокчейн",
	"Managed Grafana": "Управляемая Grafana",
	Monitron: Monitron,
	"MQ Message Broker": "Брокер сообщений IoT",
	Neptune: Neptune,
	"Network Firewall": "Сетевой брандмауэр",
	Neuron: Neuron,
	"Nimble Studio": "Студия Nimble",
	One: One,
	"OpenSearch Service (OSS)": "Сервис OpenSearch",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "Частный 5G",
	"Private Certificate Authority": "Частный центр сертификации",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "Q ",
	"Quantum Solutions Lab": "Лаборатория квантовых решений",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "Служба реляционных баз данных (RDS)",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost Private",
	"Resilience Hub": "Центр обеспечения устойчивости",
	"Resource Access Manager": "Диспетчер доступа к ресурсам",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Менеджер секретов",
	"Security Hub": "Центр безопасности",
	"Security Lake": "Security Lake",
	"Server Migration Service (SMS)": "Служба миграции серверов (SMS)",
	"Serverless Application Repository": "Репозиторий бессерверных приложений",
	"Service Catalog": "AWS Service Catalog",
	"Service Management Connector": "Коннектор управления сервисами",
	Shield: Shield,
	"Simple Email Service (SES)": "Simple Email Service (SES)",
	"Simple Notification Service (SNS)": "Simple Notification Service (SNS)",
	"Simple Queue Service (SQS)": "Simple Queue Service (SQS)",
	"Simple Storage Service (S3)": "Simple Storage Service (S3)",
	"Simspace Weaver": "Simspace Weaver",
	"Single Sign-On (SSO)": "Единый вход (SSO)",
	"Snow Family": "Snow Family",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Step Functions",
	"Storage Gateway": "Storage Gateway",
	Sumerian: Sumerian,
	"Supply Chain": "Цепочка поставок",
	"Systems Manager": "Systems Manager",
	"Telco Network Builder": "Конструктор телекоммуникационных сетей",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "Проверенный доступ",
	"Verified Permissions": "Проверенные разрешения",
	"Virtual Private Cloud (VPC)": "Виртуальное частное облако (VPC)",
	"Virtual Private Network (VPN)": "Виртуальная частная сеть (VPN)",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "Брандмауэр веб‑приложений (WAF)",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
